import { NextRouter } from 'next/router'
import { ONE_LINK_thumb_cta_web } from '@/stories/strapi-4/utils/constants'
import { getLineOfBusiness } from '@/hooks/analytics/use-gtm-event'
import { addQueryParamsToApiV2 } from '@/root/helpers'

export const getAppsFlyerLink = (
  router: NextRouter,
  btnText: string,
  isIndStocks = false,
) => {
  const { pathname, query, asPath } = router
  const { utm_source, utm_medium, utm_campaign } = query
  const lob = getLineOfBusiness(pathname).split(' ').join('-')
  const ctaLabel = btnText.split(' ').join('-')
  let queries = {}
  queries = {
    ...(ctaLabel && { cta_label: ctaLabel }),
    ...(lob && { page_lob: lob }),
    ...(utm_source && { utm_source }),
    ...(utm_medium && { utm_medium }),
    ...(utm_campaign && { utm_campaign }),
    ...(asPath && { page_url: asPath }),
  }
  const url = isIndStocks
    ? 'https://indstocks.onelink.me/wIpF/zvq8hfbg'
    : window.AF_SMART_SCRIPT_RESULT?.clickURL ?? ONE_LINK_thumb_cta_web

  const link = addQueryParamsToApiV2(url, queries)
  return link
}
